import { formatISO } from 'date-fns'
import getApi from '../../api'

export const terminatePatientTreatment = (id: string, endAt: Date) =>
  getApi().put<void>(`/treatments/${id}/end`, {
    endAt: formatISO(endAt),
  })
